import { render } from "./subscriptionHistory.vue?vue&type=template&id=72980e24&scoped=true"
import script from "./subscriptionHistory.vue?vue&type=script&lang=js"
export * from "./subscriptionHistory.vue?vue&type=script&lang=js"

import "./subscriptionHistory.vue?vue&type=style&index=0&id=72980e24&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72980e24"]])

export default __exports__